import React, { useContext, useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { 
  FaPhoneAlt, 
  FaWhatsapp, 
  FaClock, 
  FaMapMarkerAlt, 
  FaDirections, 
  FaStore, 
  FaWrench,
  FaCheckCircle
} from 'react-icons/fa';
import { store } from '../../App';
import Footer from '../Footer';
import { apiUrl } from '../Constants';
import '../../css/LocationsPage.css';

// Fallback seed data in case API is offline
const SEED_SHOWROOMS = [
  {
    id: 1,
    show_room_name_en: "Al Qurum Showroom",
    show_room_name_ar: "معرض القرم",
    address_en: "Al Qurum, Muscat",
    address_ar: "القرم، مسقط",
    landmark_en: "Bahwan Premises, diagonally opposite Qurum City Center, Al Qurum",
    landmark_ar: "مبنى بهوان، مقابل سيتي سنتر القرم",
    contacts: ["Toll Free: 80050800", "Mobile: 79999073"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2794.2595257188273!2d58.492442!3d23.609262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDM2JzMzLjMiTiA1OMKwMjknMzIuOCJF!5e1!3m2!1sen!2sin!4v1768894154353!5m2!1sen!2sin"
  },
  {
    id: 2,
    show_room_name_en: "Suhar Showroom",
    show_room_name_ar: "معرض صحار",
    address_en: "Suhar",
    address_ar: "صحار",
    landmark_en: "Al Bahja Street",
    landmark_ar: "شارع البهجة",
    contacts: ["Toll Free: 80050800", "Mobile: 95351200"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1422766.226049702!2d55.5305507!3d24.322487!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8b5d42a5b887a5%3A0x9c40acd375ab9c6f!2sChangan%20Oman%2C%20Sohar!5e1!3m2!1sen!2sin!4v1768894245446!5m2!1sen!2sin"
  },
  {
    id: 3,
    show_room_name_en: "Barka",
    show_room_name_ar: "معرض بركاء",
    address_en: "Barka",
    address_ar: "بركاء",
    landmark_en: "Near Lulu Hypermarket, next to Al Madina Insurance office, Barka.",
    landmark_ar: "بالقرب من لولو هايبر ماركت، بجوار مكتب المدينة للتأمين، بركاء.",
    contacts: ["Toll Free: 80050800", "Showroom: 96629010"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d357502.29312140896!2d57.5742911!3d23.6689047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dc4d30fe70591%3A0x6eb3cc9e189f4da4!2sCHANGAN%20AUTO%20SHOWROOM!5e1!3m2!1sen!2sin!4v1768894287914!5m2!1sen!2sin"
  },
  {
    id: 4,
    show_room_name_en: "Nizwa",
    show_room_name_ar: "معرض نزوى",
    address_en: "Nizwa",
    address_ar: "نزوى",
    landmark_en: "Near Al Diyar Hotel and Shell Oman Filling Station",
    landmark_ar: "بالقرب من فندق الديار ومحطة شل عُمان",
    contacts: ["Toll Free: 80050800", "Showroom: 96628930"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2809.0527555128688!2d57.533035!3d22.905357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDU0JzE5LjMiTiA1N8KwMzEnNTguOSJF!5e1!3m2!1sen!2sin!4v1768894343963!5m2!1sen!2sin"
  },
  {
    id: 5,
    show_room_name_en: "Ibri",
    show_room_name_ar: "معرض عبري",
    address_en: "Ibri",
    address_ar: "عبري",
    landmark_en: "Near National Bank Oman, Ibri",
    landmark_ar: "بالقرب من البنك الوطني العماني، عبري",
    contacts: ["Toll Free: 80050800", "Showroom: 96628930"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2802.55087923698!2d56.480489999999996!3d23.217218000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDEzJzAyLjAiTiA1NsKwMjgnNDkuOCJF!5e1!3m2!1sen!2sin!4v1768894382887!5m2!1sen!2sin"
  },
  {
    id: 6,
    show_room_name_en: "Sur",
    show_room_name_ar: "معرض صور",
    address_en: "Sur",
    address_ar: "صور",
    landmark_en: "Near Badr Al Sama Hospital, Sur",
    landmark_ar: "بالقرب من مستشفى بدر السماء، صور",
    contacts: ["Toll Free: 80050800", "Showroom: 96628920"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2815.9720508015757!2d59.49772300000001!3d22.569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDM0JzA4LjQiTiA1OcKwMjknNTEuOCJF!5e1!3m2!1sen!2sin!4v1768894470282!5m2!1sen!2sin"
  },
  {
    id: 7,
    show_room_name_en: "Salalah",
    show_room_name_ar: "معرض صلالة",
    address_en: "Salalah",
    address_ar: "صلالة",
    landmark_en: "Sanaiya Area, near Bank Muscat",
    landmark_ar: "المنطقة الصناعية، بالقرب من بنك مسقط",
    contacts: ["Toll Free: 80050800", "Showroom: 96629050"],
    timing_en: ["Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM", "Friday: Closed"],
    timing_ar: ["السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2915.977539192713!2d54.04372799999999!3d17.018175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDAxJzA1LjQiTiA1NMKwMDInMzcuNCJF!5e1!3m2!1sen!2sin!4v1768894509980!5m2!1sen!2sin"
  }
];

const SEED_SERVICE_CENTERS = [
  {
    id: 101,
    service_center_name_en: "Azaiba Service Center",
    service_center_name_ar: "مركز خدمة العذيبة",
    address_en: "Azaiba",
    address_ar: "العذيبة",
    landmark_en: "Near Al Meera Hypermarket, Azaiba",
    landmark_ar: "بالقرب من الميرة هايبر ماركت، العذيبة",
    contacts: ["Toll Free: 80050800", "Mobile: 94589715 / 97440789"],
    timing_en: ["Sun-Thu: 7:30 AM - 7:00 PM", "Saturday: 8:30 AM - 1:00 PM, 2:00 PM - 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 7:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.634026362879!2d58.375218!3d23.581561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ffc569f7e8a9%3A0xd64b973efbe43666!2sAl%20Meera%20Hypermarket%20Azaiba!5e0!3m2!1sen!2som!4v1710000000000"
  },
  {
    id: 102,
    service_center_name_en: "Wadi Kabir Service Center",
    service_center_name_ar: "مركز خدمة وادي كبير",
    address_en: "Wadi Kabir",
    address_ar: "الوادي الكبير",
    landmark_en: "Near Nesto Hypermarket, Wadi Kabir",
    landmark_ar: "بالقرب من نستو هايبر ماركت، الوادي الكبير",
    contacts: ["Toll Free: 80050800", "Mobile: 96580057"],
    timing_en: ["Sun-Thu: 7:30 AM - 7:00 PM", "Saturday: 8:30 AM - 1:00 PM, 2:00 PM - 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 7:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.07726550787!2d58.558362!3d23.547141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91f7c32bf28bcf%3A0xe75a89ee18e9766e!2sNesto%20Hypermarket%20Wadi%20Kabir!5e0!3m2!1sen!2som!4v1710000000001"
  },
  {
    id: 103,
    service_center_name_en: "Al Amerat Service Center",
    service_center_name_ar: "مركز خدمة العامرات",
    address_en: "Al Amerat",
    address_ar: "العامرات",
    landmark_en: "Lulu Hypermarket, Al Amerat",
    landmark_ar: "لولو هايبر ماركت، العامرات",
    contacts: ["Toll Free: 80050800"],
    timing_en: ["Sun–Thu: 8:30 AM – 7:00 PM", "Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.8398436156385!2d58.497554!3d23.490757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91f1a511ecf3f9%3A0x6d9e03d3f23a9a16!2sLulu%20Hypermarket%20Amerat!5e0!3m2!1sen!2som!4v1710000000002"
  },
  {
    id: 104,
    service_center_name_en: "Mabella Service Center",
    service_center_name_ar: "مركز خدمة المعبيلة",
    address_en: "Mabella",
    address_ar: "المعبيلة",
    landmark_en: "Al Imar Street, Street No. – 7713",
    landmark_ar: "شارع العمار، سكة رقم 7713",
    contacts: ["Toll Free: 80050800", "Mobile: 9533 0380"],
    timing_en: ["Sun–Thu: 7:30 AM – 7:00 PM", "Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 7:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3654.512345678!2d58.121111!3d23.642222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM4JzMyLjAiTiA1OMKwMDcnMTYuMCJF!5e0!3m2!1sen!2som!4v1710000000003"
  },
  {
    id: 105,
    service_center_name_en: "Rusayl – Bodyshop",
    service_center_name_ar: "ورشة هياكل الرسيل",
    address_en: "Rusayl",
    address_ar: "الرسيل",
    landmark_en: "Near Oriental Ready Mix",
    landmark_ar: "بالقرب من أورينتال للخرسانة الجاهزة",
    contacts: ["Toll Free: 80050800", "Mobile: 97163035"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.712345678!2d58.175556!3d23.535556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMyJzA4LjAiTiA1OMKwMTAnMzIuMCJF!5e0!3m2!1sen!2som!4v1710000000004"
  },
  {
    id: 106,
    service_center_name_en: "Barka Service Center",
    service_center_name_ar: "مركز خدمة بركاء",
    address_en: "Barka",
    address_ar: "بركاء",
    landmark_en: "Near Lulu Hypermarket, next to Al Madina Insurance office, Barka.",
    landmark_ar: "بالقرب من لولو هايبر ماركت، بجوار مكتب المدينة للتأمين، بركاء.",
    contacts: ["Toll Free: 80050800", "Mobile: 9509 4517"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d357502.29312140896!2d57.5742911!3d23.6689047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dc4d30fe70591%3A0x6eb3cc9e189f4da4!2sCHANGAN%20AUTO%20SHOWROOM!5e1!3m2!1sen!2sin!4v1768894287914!5m2!1sen!2sin"
  },
  {
    id: 107,
    service_center_name_en: "Suhar Service Center",
    service_center_name_ar: "مركز خدمة صحار",
    address_en: "Suhar",
    address_ar: "صحار",
    landmark_en: "Al Bahja Street",
    landmark_ar: "شارع البهجة",
    contacts: ["Toll Free: 80050800", "Mobile: 9400 0961"],
    timing_en: ["Sun–Thu: 7:30 AM – 7:00 PM", "Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 7:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1422766.226049702!2d55.5305507!3d24.322487!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8b5d42a5b887a5%3A0x9c40acd375ab9c6f!2sChangan%20Oman%2C%20Sohar!5e1!3m2!1sen!2sin!4v1768894245446!5m2!1sen!2sin"
  },
  {
    id: 108,
    service_center_name_en: "Nizwa Service Center",
    service_center_name_ar: "مركز خدمة نزوى",
    address_en: "Nizwa",
    address_ar: "نزوى",
    landmark_en: "Near Al Diyar Hotel and Shell Oman Filling Station",
    landmark_ar: "بالقرب من فندق الديار ومحطة شل عُمان",
    contacts: ["Toll Free: 80050800", "Mobile: 9709 7968"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2809.0527555128688!2d57.533035!3d22.905357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDU0JzE5LjMiTiA1N8KwMzEnNTguOSJF!5e1!3m2!1sen!2sin!4v1768894343963!5m2!1sen!2sin"
  },
  {
    id: 109,
    service_center_name_en: "Ibri Service Center",
    service_center_name_ar: "مركز خدمة عبري",
    address_en: "Ibri",
    address_ar: "عبري",
    landmark_en: "Near National Bank Oman, Ibri",
    landmark_ar: "بالقرب من البنك الوطني العماني، عبري",
    contacts: ["Toll Free: 80050800", "Mobile: 9418 9060"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2802.55087923698!2d56.480489999999996!3d23.217218000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDEzJzAyLjAiTiA1NsKwMjgnNDkuOCJF!5e1!3m2!1sen!2sin!4v1768894382887!5m2!1sen!2sin"
  },
  {
    id: 110,
    service_center_name_en: "Sur Service Center",
    service_center_name_ar: "مركز خدمة صور",
    address_en: "Sur",
    address_ar: "صور",
    landmark_en: "Near Badr Al Sama Hospital, Sur",
    landmark_ar: "بالقرب من مستشفى بدر السماء، صور",
    contacts: ["Toll Free: 80050800", "Mobile: 9410 1939"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2815.9720508015757!2d59.49772300000001!3d22.569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDM0JzA4LjQiTiA1OcKwMjknNTEuOCJF!5e1!3m2!1sen!2sin!4v1768894470282!5m2!1sen!2sin"
  },
  {
    id: 111,
    service_center_name_en: "Duqm Service Center",
    service_center_name_ar: "مركز خدمة الدقم",
    address_en: "Duqm",
    address_ar: "الدقم",
    landmark_en: "Near Hashar Roundabout, Duqm",
    landmark_ar: "بالقرب من دوار الحشار، الدقم",
    contacts: ["Toll Free: 80050800"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3698.212345678!2d57.701111!3d19.665556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDM5JzU2LjAiTiA1N8KwNDInMDQuMCJF!5e0!3m2!1sen!2som!4v1710000000005"
  },
  {
    id: 112,
    service_center_name_en: "Maweleh Service Center",
    service_center_name_ar: "مركز خدمة الموالح",
    address_en: "Maweleh",
    address_ar: "الموالح",
    landmark_en: "Near Old Vegetable Market, Nizwa road.",
    landmark_ar: "بالقرب من سوق الخضار القديم، طريق نزوى.",
    contacts: ["Toll Free: 80050800", "Mobile: 79913319 / 7913 7980"],
    timing_en: ["Sun-Thu: 7:30 AM - 7:00 PM", "Saturday: 8:30 AM - 1:00 PM, 2:00 PM - 5:30 PM", "Friday: Closed"],
    timing_ar: ["الأحد - الخميس: 7:30 ص - 7:00 م", "السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.412345678!2d58.245556!3d23.605556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM2JzIwLjAiTiA1OMKwMTQnNDQuMCJF!5e0!3m2!1sen!2som!4v1710000000006"
  },
  {
    id: 113,
    service_center_name_en: "Salalah Service Center",
    service_center_name_ar: "مركز خدمة صلالة",
    address_en: "Salalah",
    address_ar: "صلالة",
    landmark_en: "Sanaiya Area, near Bank Muscat",
    landmark_ar: "المنطقة الصناعية، بالقرب من بنك مسقط",
    contacts: ["Toll Free: 80050800", "Mobile: 9533 4250"],
    timing_en: ["Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM", "Friday & Saturday: Closed"],
    timing_ar: ["الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م", "الجمعة والسبت: مغلق"],
    map_url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2915.977539192713!2d54.04372799999999!3d17.018175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDAxJzA1LjQiTiA1NMKwMDInMzcuNCJF!5e1!3m2!1sen!2sin!4v1768894509980!5m2!1sen!2sin"
  }
];

export default function LocationsPage({ type: initialType }) {
  const [lang] = useContext(store); // lang === true: Arabic, false: English
  const location = useLocation();

  // Determine whether this is Showroom or Service Center based on prop or URL
  const isServicePage = initialType === 'service' || 
    location.pathname.includes('service-center') || 
    location.pathname.includes('services-center');

  const [activeTab, setActiveTab] = useState(isServicePage ? 'service' : 'showroom');
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sync tab with URL if prop or path changes
  useEffect(() => {
    setActiveTab(isServicePage ? 'service' : 'showroom');
  }, [isServicePage, location.pathname]);

  // Fetch dynamic location data from API (with fallback)
  useEffect(() => {
    setLoading(true);
    const isShowroom = activeTab === 'showroom';
    const endpoint = isShowroom ? 'getShowrooms' : 'getServiceCenters';
    const fallbackData = isShowroom ? SEED_SHOWROOMS : SEED_SERVICE_CENTERS;

    const isLocal = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    const primaryUrl = isLocal 
      ? `http://localhost/foton-oman-backend/api/${endpoint}`
      : `${apiUrl || 'https://dev10.sbagh.com/api/'}${endpoint}`;

    const secondaryUrl = `${apiUrl || 'https://dev10.sbagh.com/api/'}${endpoint}`;

    axios.get(primaryUrl)
      .then(res => {
        if (res?.data?.data?.locations && Array.isArray(res.data.data.locations) && res.data.data.locations.length > 0) {
          setLocations(res.data.data.locations);
        } else {
          setLocations(fallbackData);
        }
      })
      .catch(err => {
        console.warn(`Primary ${endpoint} endpoint failed, attempting secondary/fallback:`, err?.message);
        axios.get(secondaryUrl)
          .then(res2 => {
            if (res2?.data?.data?.locations && Array.isArray(res2.data.data.locations) && res2.data.data.locations.length > 0) {
              setLocations(res2.data.data.locations);
            } else {
              setLocations(fallbackData);
            }
          })
          .catch(() => {
            setLocations(fallbackData);
          });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activeTab]);

  // Parse helper for timing list
  const parseList = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
      try {
        const parsed = json_decode_safe(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        // split by comma or newline
      }
      return [raw];
    }
    return [];
  };

  const json_decode_safe = (str) => {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  };

  // Content dictionary
  const t = {
    showroomsTitle: lang ? "صالات العرض" : "SHOWROOMS",
    serviceCentersTitle: lang ? "مراكز الخدمة" : "SERVICE CENTERS",
    salesCentersHeading: lang ? "مراكز المبيعات" : "Sales Centers",
    salesDesc: lang 
      ? "تمتلك مبيعات فوتون شبكة تغطي جميع أنحاء عمان. في معظم المواقع، تتوفر مرافق حصرية تلبي متطلبات المبيعات للعملاء. في المواقع الرئيسية، تم تحديث منافذنا الآن بمعايير عالمية لتقديم المبيعات وقطع الغيار والخدمة للعملاء."
      : "FOTON Sales has its network spread all across Oman. In most locations, exclusive facilities catering to the sales requirements of customers are available. At major locations, our outlets are now upgraded with global standards for delivering Sales, Spare-parts and Service to customers.",
    serviceDesc: lang 
      ? "تمتلك خدمة فوتون شبكة تغطي جميع أنحاء عمان. في معظم المواقع، تتوفر مرافق حصرية تلبي متطلبات الخدمة للعملاء. في المواقع الرئيسية، تم تحديث منافذنا الآن بمعايير عالمية لتقديم المبيعات وقطع الغيار والخدمة للعملاء."
      : "FOTON Service has its network spread all across Oman. In most locations, exclusive facilities catering to the service requirements of customers are available. At major locations, our outlets are now upgraded with global standards for delivering Sales, Spare-parts and Service to customers.",
    contactDetails: lang ? "تفاصيل الاتصال" : "Contact Details",
    workingTiming: lang ? "أوقات العمل" : "Working Timing",
    nearestLandmark: lang ? "أقرب معلم" : "Nearest Landmark",
    getDirections: lang ? "الاتجاهات على الخريطة" : "Get Directions",
    tollFree: lang ? "الرقم المجاني" : "Toll Free",
    showroom: lang ? "صالة العرض" : "Showroom",
    mobile: lang ? "الجوال" : "Mobile",
    tabShowroom: lang ? "صالات العرض" : "Showrooms",
    tabService: lang ? "مراكز الخدمة" : "Service Centers"
  };

  // Helper to render individual location card
  const renderLocationCard = (item) => {
    const name = lang ? (item.show_room_name_ar || item.service_center_name_ar || item.name_ar || item.show_room_name_en || item.service_center_name_en || item.name) : (item.show_room_name_en || item.service_center_name_en || item.name);
    const landmark = lang ? (item.landmark_ar || item.landmark_en || item.landmark) : (item.landmark_en || item.landmark);
    
    // Contacts list
    let contacts = item.contacts_list || item.contacts;
    if (typeof contacts === 'string') {
      try {
        contacts = JSON.parse(contacts);
      } catch (e) {
        contacts = [contacts];
      }
    }
    if (!Array.isArray(contacts)) contacts = [];

    // Timing list
    let timing = lang 
      ? (item.timing_ar_list || item.timing_ar || item.timing_en_list || item.timing_en || item.timing)
      : (item.timing_en_list || item.timing_en || item.timing);
    if (typeof timing === 'string') {
      try {
        timing = JSON.parse(timing);
      } catch (e) {
        timing = [timing];
      }
    }
    if (!Array.isArray(timing)) timing = [];

    const mapUrl = item.map_url || item.mapUrl;

    return (
      <div 
        key={item.id || item.show_room_name_en || item.service_center_name_en} 
        className="location-card"
        data-aos="fade-up"
      >
        {/* Left Side: 3 Detail Boxes */}
        <div className={`card-details-pane ${!mapUrl ? 'full-width' : ''}`}>
          <h3 className="location-name">{name}</h3>

          {/* 1. Contact Details */}
          <div className="info-block">
            <div className="block-header">
              <FaPhoneAlt className="block-icon" />
              <span>{t.contactDetails}</span>
            </div>
            <div className="block-body">
              {contacts.map((contact, idx) => {
                const cLower = String(contact).toLowerCase();
                const isWhatsapp = cLower.includes('whatsapp');
                // Extract clean phone number
                const cleanNum = contact.replace(/[^0-9+]/g, '');

                return (
                  <div key={idx} className="contact-row">
                    {isWhatsapp ? (
                      <>
                        <FaWhatsapp className="contact-icon whatsapp" />
                        <a 
                          href={`https://wa.me/${cleanNum.startsWith('968') ? cleanNum : '968' + cleanNum}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="contact-link"
                        >
                          {contact}
                        </a>
                      </>
                    ) : (
                      <>
                        <FaPhoneAlt className="contact-icon phone" />
                        {cleanNum ? (
                          <a href={`tel:${cleanNum}`} className="contact-link">
                            {contact}
                          </a>
                        ) : (
                          <span>{contact}</span>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* 2. Working Timing */}
          <div className="info-block">
            <div className="block-header">
              <FaClock className="block-icon" />
              <span>{t.workingTiming}</span>
            </div>
            <div className="block-body text-sm">
              {timing.map((time, idx) => (
                <div key={idx} className="timing-row">
                  {time}
                </div>
              ))}
            </div>
          </div>

          {/* 3. Nearest Landmark */}
          {landmark && (
            <div className="info-block">
              <div className="block-header">
                <FaMapMarkerAlt className="block-icon" />
                <span>{t.nearestLandmark}</span>
              </div>
              <div className="block-body">
                <p className="landmark-text">{landmark}</p>
              </div>
            </div>
          )}
        </div>

        {/* Right Side: Google Maps Embed */}
        {mapUrl && (
          <div className="card-map-pane">
            <iframe
              src={mapUrl}
              title={name}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="map-iframe"
            />
          </div>
        )}
      </div>
    );
  };

  const isShowroom = activeTab === 'showroom';
  const pageTitle = isShowroom ? t.showroomsTitle : t.serviceCentersTitle;
  const pageDesc = isShowroom ? t.salesDesc : t.serviceDesc;

  // For Showrooms: Split into main showrooms (id 1, 2: Qurum, Suhar) and sales centers
  const mainShowrooms = isShowroom ? locations.slice(0, 2) : [];
  const otherShowrooms = isShowroom ? locations.slice(2) : [];

  return (
    <div className={`locations-page-wrapper ${lang ? 'rtl-direction' : 'ltr-direction'}`}>
      <Helmet>
        <title>{pageTitle} | Foton Oman</title>
        <meta name="description" content={pageDesc} />
      </Helmet>

      {/* ================= HERO BANNER ================= */}
      <section 
        className="locations-hero-banner"
        style={{
          backgroundImage: isShowroom 
            ? "url('/Images/Banners/foton-family-banner.jpg')" 
            : "url('/Images/service/service_banner.jpg')"
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container hero-content-container">
          <div className="hero-text-box" data-aos="fade-up">
            <h1 className="hero-main-title">{pageTitle}</h1>
            <div className="hero-red-indicator"></div>
          </div>
        </div>
      </section>

      {/* ================= SWITCHER TABS ================= */}
      <section className="tabs-navigation-section">
        <div className="container">
          <div className="tabs-switcher-wrapper">
            <Link 
              to="/show-rooms" 
              className={`switcher-btn ${activeTab === 'showroom' ? 'active' : ''}`}
            >
              <FaStore className="btn-icon" />
              <span>{t.tabShowroom}</span>
            </Link>
            <Link 
              to="/service-centers" 
              className={`switcher-btn ${activeTab === 'service' ? 'active' : ''}`}
            >
              <FaWrench className="btn-icon" />
              <span>{t.tabService}</span>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= MAIN CONTENT LIST ================= */}
      <section className="locations-content-section">
        <div className="container">
          {/* Overview Network Description */}
          <div className="network-overview-desc" data-aos="fade-up">
            <p>{pageDesc}</p>
          </div>

          {/* Cards List */}
          {loading ? (
            <div className="locations-loading-spinner">
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : isShowroom ? (
            <div className="locations-cards-container">
              {/* Top Main Showrooms (Qurum & Suhar) */}
              {mainShowrooms.map(renderLocationCard)}

              {/* Subheading: Sales Centers */}
              {otherShowrooms.length > 0 && (
                <div className="sales-centers-subheading" data-aos="fade-up">
                  <div className="subheading-accent"></div>
                  <h2>{t.salesCentersHeading}</h2>
                </div>
              )}

              {/* Remaining Sales Centers (Barka, Nizwa, Ibri, Sur, Salalah) */}
              {otherShowrooms.map(renderLocationCard)}
            </div>
          ) : (
            <div className="locations-cards-container">
              {/* All Service Centers */}
              {locations.map(renderLocationCard)}
            </div>
          )}
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <Footer />
    </div>
  );
}
